<script src="src/app/components/main/ui-components/saved-payment-methods-dropdown/saved-payment-method-dropdown.service.ts"></script>

<mat-drawer-container>
  <mat-drawer position="end" [opened]="!(isMobile$ | async)" [mode]="sideDrawerMode$ | async">
    <app-payments-sidebar (openedChange)="onSidebarOpenedChange($event)"></app-payments-sidebar>
  </mat-drawer>
  <mat-drawer-content [ngClass]="{ 'mobile-mat-drawer-content pb-6': isMobile$ | async }">
    <div [hidden]="hideComponent">
      <div class="grid-cont grid-cont--xl">
        @if (arePayablesEmpty$ | async) {
          @if (showInvoicesTableSummaryInEmptyState$ | async) {
            <div class="mb--100">
              <app-invoices-table-summary></app-invoices-table-summary>
            </div>
          }
          <app-empty-page
            data-cy="invoices-empty-state"
            title="No invoices yet."
            text="When your firm sends you an invoice, it will appear here."
          ></app-empty-page>
        } @else {
          <div class="grid-row grid-row--aic invoice-header">

            <div class="grid-col grid-col--auto">
              <h1 class="mb-2">Invoices</h1>
            </div>

            @if (shouldShowInvoicesTableSummary$ | async) {
              <div class="grid-col grid-col--auto w-100 mb--100">
                <app-invoices-table-summary></app-invoices-table-summary>
              </div>
            }

            <div class="grid-col grid-col--auto invoice-header__container">
              <div *ngIf="selectedPayablesCount$ | async as selectedPayablesCount">
                <span class="mt--0125 p tc--error">{{ selectedPayablesCount }} unpaid invoices selected</span>
              </div>
            </div>

            <div class="grid-col"></div>

            <div class="grid-col grid-col--4">
              <input
                *ngIf="!configService.isMobile" type="text" placeholder="Search"
                class="form-input form-input--search" data-cy="search"
                (keyup)="getSearchString($event.target['value'])"
              >
            </div>
          </div>

          <app-unpaid [searchString]="searchString" (onPayWithoutInvoice)="onPayWithoutInvoice()"></app-unpaid>
        }

        <app-client-portal-footer class="mt-4"></app-client-portal-footer>
      </div>
    </div>
  </mat-drawer-content>
</mat-drawer-container>

<div *ngIf="configService.isMobile && !(isSideDrawerOpen$ | async)" class="footbar active">
  <div class="grid-row grid-row--smg">
    <div class="grid-col grid-col--6">
      <button
        andButton
        color="secondary"
        size="large"
        [disabled]="(selectedPayablesCount$ | async) === 0"
        (click)="onNavigateToReviewAndPay()"
        class="w-100"
        data-cy="review-and-pay"
      >
        Review & Pay
      </button>
    </div>

    <div class="grid-col grid-col--6">
      <button
        andButton
        color="primary"
        size="large"
        (click)="openSidebar()"
        data-cy="go-to-payment">
        <span>Go to Payment</span>
        <svg
          viewBox="0 0 24 24" width="16" height="16" stroke="currentColor" stroke-width="2" fill="none"
          stroke-linecap="round" stroke-linejoin="round" class="button__icon"
        >
          <line x1="5" y1="12" x2="19" y2="12"></line>
          <polyline points="12 5 19 12 12 19"></polyline>
        </svg>
      </button>
    </div>
  </div>
</div>
